import { render, staticRenderFns } from "./SearchSuggestions.vue?vue&type=template&id=28cc2508"
import script from "./SearchSuggestions.vue?vue&type=script&lang=ts"
export * from "./SearchSuggestions.vue?vue&type=script&lang=ts"
import style0 from "./SearchSuggestions.vue?vue&type=style&index=0&id=28cc2508&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports